import { render, staticRenderFns } from "./marketing-shop.vue?vue&type=template&id=21b3bea6&scoped=true&"
import script from "./marketing-shop.vue?vue&type=script&lang=js&"
export * from "./marketing-shop.vue?vue&type=script&lang=js&"
import style0 from "./marketing-shop.vue?vue&type=style&index=0&id=21b3bea6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b3bea6",
  null
  
)

export default component.exports